module.exports = __webpack_public_path__ + "static/media/invoice.7f2cac9a.svg";